import { DataExplorerNode } from "./DataExplorerNode";
import { formatSize } from "./safetensors";


export interface DataExplorerFolderProps {
    name: string;
    depth: number;
    data: any;
    download: any;
    selectTensor: any;
    selectedTensor: any;
    expanded: string[];
    toggleExpanded: (p: string) => void;
}

export const DataExplorerFolder = (props: DataExplorerFolderProps) => {
    const { name, depth, data, download, selectTensor, selectedTensor, expanded, toggleExpanded } = props;

    const isExpanded = expanded.includes(data.path);

    const { unit, size } = formatSize(data.totalSize);

    return (
        <li>

            <div className="data-explorer-folder">
                <button onClick={() => toggleExpanded(data.path)} className="btn-folder-expand">
                    <div className="btn-folder-expand-text">
                        <span>{isExpanded ? '-' : '+'}</span>
                    </div>
                </button>

                <span className={"data-explorer-filename"} onClick={() => toggleExpanded(data.path)}>{name}</span>
                <span className='text-thin'> ({size} {unit})</span>
            </div>

            {isExpanded &&
                <DataExplorerNode
                    data={data}
                    depth={depth + 1}
                    download={download}
                    selectTensor={selectTensor}
                    selectedTensor={selectedTensor}
                    expanded={expanded}
                    toggleExpanded={toggleExpanded}
                />
            }
        </li>
    );
};
